import { classNames } from '@ember-decorators/component';
import Super from 'ember-simplepractice/components/shared/empty-state';
import styles from './empty-state.module.scss';

@classNames(styles.component)
export default class SharedEmptyState extends Super {}
